import React from "react";
import OnboardingLayout from "../../layout/OnboardingLayout";
import useOnboardingFlow from "../../hooks/useOnboardingFlow";
import LoginStep from "./LoginStep";
import PasswordStep from "./PasswordStep";
import SurveyStep from "./SurveyStep";
import ReviewStep from "./ReviewStep";
import SuccessStep from "./SuccessStep";

function MessageStep({ title, message, actionLabel, onAction, loading }) {
  return (
    <div className="onboarding-card-inner">
      <div className="onboarding-step-head">
        <div>
          <h2>{title}</h2>
          <p>{message}</p>
        </div>
      </div>
      {actionLabel && (
        <div className="onboarding-button-row">
          <span />
          <button
            className="onboarding-button onboarding-button--primary"
            type="button"
            onClick={onAction}
            disabled={loading}
          >
            {loading ? "Comprobando…" : actionLabel}
          </button>
        </div>
      )}
    </div>
  );
}

export default function OnboardingPage() {
  const flow = useOnboardingFlow();
  let content = null;

  if (flow.stage === "login") {
    content = (
      <LoginStep
        email={flow.email}
        onEmailChange={flow.setEmail}
        onSubmit={flow.login}
        loading={flow.isBusy}
        error={flow.error}
        initialAlreadyUpdated={flow.needsReauthentication}
      />
    );
  } else if (flow.stage === "password") {
    content = (
      <PasswordStep
        onSubmit={flow.changePassword}
        loading={flow.isBusy}
        error={flow.error}
      />
    );
  } else if (flow.stage === "survey") {
    content = (
      <SurveyStep
        questions={flow.questions}
        questionIndex={flow.questionIndex}
        answers={flow.answers}
        fieldErrors={flow.fieldErrors}
        onAnswer={flow.setAnswer}
        onContinue={flow.continueSurvey}
        onBack={flow.goBack}
        error={flow.error}
      />
    );
  } else if (flow.stage === "review") {
    content = (
      <ReviewStep
        questions={flow.questions}
        answers={flow.answers}
        error={flow.error}
        loading={flow.isSubmitting || flow.isBusy}
        onBack={flow.goBack}
        onSubmit={flow.submitSurvey}
      />
    );
  } else if (flow.stage === "success") {
    content = (
      <SuccessStep
        passwordWasUpdated={flow.passwordWasUpdated}
        alreadyCompleted={flow.alreadyCompleted}
        onClose={flow.close}
      />
    );
  } else if (flow.stage === "recovery") {
    content = (
      <MessageStep
        title="No pudimos comprobar tu ficha"
        message={flow.error}
        actionLabel="Revisar estado"
        onAction={flow.retryStatus}
        loading={flow.isBusy}
      />
    );
  } else if (flow.stage === "uncertain") {
    content = (
      <MessageStep
        title="Revisemos el estado antes de continuar"
        message={flow.error}
        actionLabel="Comprobar estado"
        onAction={() => flow.reconcileSubmission()}
        loading={flow.isBusy}
      />
    );
  } else if (flow.stage === "blocked") {
    content = (
      <div className="onboarding-card-inner">
        <p className="onboarding-error" role="alert">{flow.error}</p>
        <p className="onboarding-step-copy">
          El equipo de IBICARE debe revisar el catálogo de esta ficha antes de
          que puedas continuar.
        </p>
      </div>
    );
  } else {
    content = (
      <div className="onboarding-success" role="status" aria-live="polite">
        <div className="onboarding-success-mark" aria-hidden="true">✓</div>
        <h2>El recorrido está cerrado</h2>
        <p>Puedes cerrar esta pestaña. No has entrado al dashboard.</p>
      </div>
    );
  }

  return (
    <OnboardingLayout>{content}</OnboardingLayout>
  );
}
